<div class="flex">
    <button class="mr-3" *ngIf="user.is_impersonate"
            mat-raised-button
            color="primary"
            (click)="leaveImpersonateUser()">
        <i class="mr-2 icon-size-4 fas fa-sign-in color-white"></i>
        <span class="ml-2">{{"section.users.leave_impersonate" | translate}}</span>
    </button>

    <!-- Button -->
    <button
        mat-button
        [matMenuTriggerFor]="userActions">
    <span class="flex items-center">
        <span class="mr-2">{{'common.menu.user.account' | translate}}</span>
        <i class="far fa-lg fa-user-circle"></i>
    </span>
    </button>
</div>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>{{'common.menu.user.logged_as' | translate}}</span>
            <span class="mt-1.5 text-md font-medium">{{user.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item
            (click)="userProfile()">
        <i class="far mr-2 fa-user-circle"></i>
        <span>{{'common.menu.user.profile' | translate}}</span>
    </button>
    <!-- <button mat-menu-item
            (click)="credit()">
        <i class="far fa-credit-card mr-2"></i>
        <span>Dobít kredit</span>
    </button> -->
    <button mat-menu-item
            (click)="settings()">
        <i class="far mr-2 fa-cog"></i>
        <span>{{'common.menu.user.settings' | translate}}</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <i class="far mr-2 fa-sign-out-alt"></i>
        <span>{{'common.menu.user.sign_out' | translate}}</span>
    </button>
</mat-menu>
